import { http } from 'utils'

import { SET_OPTED_IN } from 'vx/mutations'

// Talent opportunity state.
const state = {
  optedIn: null
}

// Talent opportunity state getters.
const getters = {}

// Talent opportunity actions.
const actions = {
  /**
   * Update a talents opportunities.
   *
   * @return Promise
   */
  packageOptIn ({ commit }, { talentId, packageId }) {
    return http.post(`/talent-opt-in/${packageId}/${talentId}`, { pending: true }).then((response) => {
      commit(SET_OPTED_IN, true)
    })
  },

  checkPackageOptInStatus ({ commit }, { talentId, packageId }) {
    return http.get(`/talent-opt-in/${packageId}/${talentId}/check`)
      .then((response) => {
        commit(SET_OPTED_IN, response.data)
      })
  }
}

// Talent opportunity state mutations.
const mutations = {
  /**
   * Set all endorsements on the state.
   *
   * @return void
   */
  [SET_OPTED_IN] (state, optedIn) {
    state.optedIn = optedIn
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
